import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css";
import icon1 from "../../assets/images/personalized_consultation.png";
import icon2 from "../../assets/images/medication.png";
import icon3 from "../../assets/images/ongoing_support.png";
import "./Signup6New.css";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import arrow from "../../assets/images/arrow.png";
import weightLossStories from "../../assets/images/weight-loss-stories.png";
const SignupPage6New: React.FC = () => {
  const navigate = useNavigate();
  const handleNext = () => {
    localStorage.setItem("step-3-completed", "true");
  };
  useEffect(() => {
    const step2Completed = localStorage.getItem("step-2-completed");
    if (step2Completed) {
      navigate("/getting-started/step-3", { replace: true });
    } else {
      navigate("/getting-started/step-2", { replace: true });
    }
  }, []);
  const step = 3;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={30} step={step} />
        <div className="signup-content">
          <div className="signup-intro-text" style={{ textAlign: "center" }}>
            <span className="highlight-blue">1,500,000 users</span>{" "}
            <span className="highlight-black">
              say Claya is the #1 supplier of
            </span>{" "}
            <span className="highlight-blue">weight loss medication</span>{" "}
            <span className="highlight-black">online!</span>
          </div>
          <div className="intro-subtext" style={{ textAlign: "center" }}>
            <span className="subtext-font">
              Claya’s pharmacy network is the #1 rated supplier of weight loss
              medication online.
            </span>
          </div>
          <div className="weight-loss-story">
            <img
              src={weightLossStories}
              alt="Story 1"
              className="story-image"
            />
          </div>
          <Link to="/getting-started/step-4">
            <button onClick={handleNext} className="next-btn sticky-btn">
              Continue{" "}
              <img src={arrow} alt="Arrow" style={{ marginLeft: "8px" }} />
            </button>
          </Link>
          <div className="suffix-content">
            <span className="content-typo">
              *Results may vary based on starting weight and program adherence.
              Medication prescriptions are at the discretion of medical
              providers and may not be suitable for everyone. Consult a
              healthcare professional before starting any weight loss program.
            </span>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage6New;
